import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Button, Checkbox, Form, Input, Select, Tabs } from 'antd';
import { Upload } from '@components';
import { parseSelfBuiltBatchFolder } from '@/utils/batch_self_built_asset_folder';

const FormItem = Form.Item;
const { Option } = Select;
const { TabPane } = Tabs;
@inject('taskStore', 'projectStore')
@observer

class AssociatedForm extends Component {
    constructor(props) {
        super(props);
        this.state = ({
            fileList: {},
            type: 2,
            selectedPackageId: undefined,
            createMode: 'single',
            batchFolderHint: ''
        });
    }

    uploadRef = React.createRef();

    batchFolderInputRef = React.createRef();

    /**
     * 获取taskStore
     */
    get store() {
        return this.props.taskStore;
    }

    /**
     * 获取projectStore
     */
    get projectStore() {
        return this.props.projectStore;
    }

    componentDidMount() {
        const { formType, currentTask } = this.props;
        if (formType === 'task_edit' && currentTask?.task_package_id) {
            this.setState({ selectedPackageId: currentTask?.task_package_id });
            this.props.onChange?.(currentTask?.task_package_id);
        }
        this.emitCreateMode('single');
    }

    emitCreateMode = (mode) => {
        this.props.onCreateModeChange?.(mode);
        this.props.formRef?.current?.setFieldsValue({
            create_mode: mode
        });
    }

    selectHandle = (v, item, arr) => {
        this.store.packageItem = item?.items;
        this.setState({ selectedPackageId: v, batchFolderHint: '' });
        this.props.onChange?.(v);
        this.store.selectedItem = undefined;
        this.props.onBatchFolderParsed?.({ items: [], skipped: [] });
    }

    taskType = (value) => {
        this.store.selectedItem = undefined;
        if (value === 1) {
            this.setState({ type: 1, batchFolderHint: '' });
            this.store.isPlanningTask = false;
            this.setState({ createMode: 'single' });
            this.emitCreateMode('single');
            this.props.onBatchFolderParsed?.({ items: [], skipped: [] });
        } else if (value === 2) {
            this.setState({ type: 2 });
            this.store.isPlanningTask = true;
            if (this.state.createMode !== 'single' && this.state.createMode !== 'batch') {
                this.setState({ createMode: 'single' });
            }
            this.emitCreateMode(this.state.createMode || 'single');
        }
    }

    onBatchFolderInputChange = (e) => {
        const list = e.target.files ? Array.from(e.target.files) : [];
        e.target.value = '';
        if (!list.length) {
            this.props.onBatchFolderParsed?.({ items: [], skipped: [] });
            this.setState({ batchFolderHint: '' });
            return;
        }
        const { items, skipped } = parseSelfBuiltBatchFolder(list);
        this.props.onBatchFolderParsed?.({ items, skipped });
        const skipNote = skipped.length
            ? `；跳过/提示 ${skipped.length} 项（含无效目录与缺图等）`
            : '';
        this.setState({
            batchFolderHint: `已解析 ${items.length} 个有效资产${skipNote}`
        });
    };

    render() {
        const { isPlanningTask, taskPackageList } = this.store;
        const { selectedPackageId, createMode, batchFolderHint } = this.state;
        const shouldShowCreateTabs = isPlanningTask && !!selectedPackageId;
        return (
            <>
                <Form.Item name="create_mode" initialValue="single" hidden>
                    <Input />
                </Form.Item>
                <div className="task-form-col-2">
                    <div className="bold required mg-b-16">选择任务包</div>
                    <FormItem
                        name="package_id"
                        rules={[{ required: true, message: '请选择任务包' }]}
                    >
                        <Select
                            className="associate-input-sz-ml"
                            placeholder="请选择任务包"
                            size="large"
                            showSearch
                            showArrow
                            onChange={this.selectHandle}
                        >
                            {taskPackageList?.map((item, idx) => (
                                <Option
                                    value={item.id}
                                    items={item}
                                    key={idx}
                                >
                                    {item.title}
                                </Option>
                            ))}
                        </Select>
                    </FormItem>
                </div>
                <div className="task-form-col-2">
                    <div className="bold required mg-b-16">任务类型</div>
                    <FormItem
                        name="package_type"
                        required
                        initialValue={1}
                    >
                        <Select
                            className="associate-input-sz-ml"
                            placeholder="请选择任务类型"
                            size="large"
                            showSearch
                            showArrow
                            onChange={this.taskType}
                        >
                            <Option value={1}>策划任务</Option>
                            <Option value={2}>自建任务</Option>

                        </Select>
                    </FormItem>
                </div>
                {
                    isPlanningTask && (
                        <>
                            {
                                shouldShowCreateTabs && (
                                    <div className="task-form-col-1">
                                        <div className="bold mg-b-16">创建方式</div>
                                        <Tabs
                                            activeKey={createMode}
                                            onChange={(key) => {
                                                this.setState({ createMode: key });
                                                this.emitCreateMode(key);
                                                if (key === 'single') {
                                                    this.setState({ batchFolderHint: '' });
                                                    this.props.onBatchFolderParsed?.({ items: [], skipped: [] });
                                                }
                                            }}
                                        >
                                            <TabPane tab="单个创建" key="single" />
                                            <TabPane tab="批量创建" key="batch" />
                                        </Tabs>
                                    </div>
                                )
                            }
                            {
                                createMode === 'single' ? (
                                    <>
                                        <div className="task-form-col-2">
                                            <div className="bold required mg-b-16">名称</div>
                                            <FormItem
                                                name="title"
                                                rules={[{ required: true, message: '请填写名称' }]}
                                            >
                                                <Input
                                                    className="associate-input-sz-ml"
                                                    placeholder="请输入名称"
                                                    size="large"
                                                    maxLength={20}
                                                />
                                            </FormItem>
                                        </div>
                                        <div className="task-form-col-2">
                                            <div className="bold required">任务图片</div>
                                            <FormItem
                                                required
                                                className="upload-form-item"
                                                name="up_images"
                                            >
                                                <Upload
                                                    ref={this.uploadRef}
                                                    fileList={this.state.fileList}
                                                    maxCount={5}
                                                />
                                            </FormItem>
                                        </div>
                                    </>
                                ) : (
                                    <div className="task-form-col-1">
                                        <div className="bold required mg-b-16">批量素材文件夹</div>
                                        <p style={{ color: '#888', fontSize: 12, marginBottom: 8 }}>
                                            请选择仅包含一层子文件夹的目录；每个子文件夹对应一个资产，同名 PNG/JPG 为预览图；含 FBX 则为 3D 模型，否则为贴图。最多处理 100 个子文件夹。
                                        </p>
                                        <input
                                            ref={this.batchFolderInputRef}
                                            type="file"
                                            style={{ display: 'none' }}
                                            multiple
                                            {...{ webkitdirectory: '', directory: '' }}
                                            onChange={this.onBatchFolderInputChange}
                                        />
                                        <Button
                                            type="default"
                                            onClick={() => this.batchFolderInputRef.current?.click()}
                                        >
                                            选择文件夹
                                        </Button>
                                        {batchFolderHint ? (
                                            <div style={{ marginTop: 8, color: '#1890ff' }}>{batchFolderHint}</div>
                                        ) : null}
                                        <Form.Item
                                            name="export_success_ids"
                                            valuePropName="checked"
                                            initialValue={false}
                                            style={{ marginTop: 12, marginBottom: 0 }}
                                        >
                                            <Checkbox>创建成功导出 ID</Checkbox>
                                        </Form.Item>
                                    </div>
                                )
                            }
                            <div className="task-form-col-2">
                                <div className="bold required mg-b-16">上传人</div>
                                {
                                    this.projectStore.loginUser?.name
                                    && (
                                        <FormItem
                                            name="associate_up"
                                            required
                                            initialValue={this.projectStore.loginUser?.name}
                                        >
                                            <Input
                                                className="associate-input-sz-ml"
                                                placeholder="请输入上传人"
                                                size="large"
                                                disabled
                                            />
                                        </FormItem>
                                    )
                                }
                            </div>
                            <div className="task-form-col-1">
                                <div className="bold required mg-b-16">素材属性</div>
                                <Form.Item required name="material_type" initialValue={2}>
                                    <Select
                                        className="associate-input-sz-ml"
                                        size="large"
                                    >
                                        <Option value={1}>项目素材</Option>
                                        <Option value={2}>泛素材</Option>
                                    </Select>
                                </Form.Item>
                            </div>
                        </>
                    )
                }
            </>
        );
    }
}

export default AssociatedForm;
